// extracted by mini-css-extract-plugin
export default {"processNav":"MultiStepProgress_processNav__O63yE","active":"MultiStepProgress_active__FWQHC","arrow":"MultiStepProgress_arrow__V+X3y"};